
import React from 'react';
import PropTypes from 'prop-types';

const HandoverMemoField = ({ label, value }) => (
	<div className="handover-field">
		<span className="handover-field-label">{label}</span>
		<span className="handover-field-value">{value}</span>
	</div>
);

HandoverMemoField.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string
};

export default HandoverMemoField;
